import { Badge, IconButton, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/AnnouncementOutlined';
import { useDashboardNoticeQuery } from '../Dashboard/api/dashboardEndPoint';
import { Link } from 'react-router-dom';

const NoticeShowHeader = () => {
  const { allNotice } = useDashboardNoticeQuery();
  return (
    <Tooltip arrow title='Notice'>
      <IconButton color='primary'>
        <Badge
          color='warning'
          badgeContent={allNotice?.length?.toString() || 0}
        >
          <Link to={'/notice'}>
            <NotificationsIcon
              sx={{ fontSize: '26px', color: 'white' }}
            />
          </Link>
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default NoticeShowHeader;
